<template lang="">
<div class="rankDet" style="height:100%">
    <div class="handleBox flex flex-ai-c">
        <el-page-header @back="goBack" content="业绩排行榜" style="color:#95A1B9"></el-page-header>
        <div class="rankTime">活动时间：{{formData.s_time}} - {{formData.e_time}}</div>
    </div>
    <div class="table" style="height:calc( 100% - 140px );padding:10px 0">
            <el-table ref="multipleTable" :data="formData.rank" highlight-current-row stripe height="calc( 100% - 40px )">
                <el-table-column prop="title" label="排行" show-overflow-tooltip align="center" width="300">
                    <template slot-scope="scope">
                        <el-image v-if="scope.$index<3" style="width:20px;height:25px" :src=" scope.$index ==0 ? require( '@/assets/one.png') : scope.$index ==1 ? require( '@/assets/two.png') : require( '@/assets/three.png')"></el-image>
                        <span v-else>{{scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="用戶昵称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="amount" label="业绩" show-overflow-tooltip align="center">
                    <template slot="header">
                        <div class="flex flex-jc-c">
                            <el-image style="width:20px;height:20px;margin-right:5px" :src="require('@/assets/yeji.png')" fit="cover"></el-image>业绩
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="奖品内容" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <div>
                            <span v-if="scope.$index < 3">{{scope.$index == 0 ? formData.reward.first.name : scope.$index == 1 ? formData.reward.second.name : formData.reward.three.name}}</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <!-- <div class="paging">
                <el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
            </div> -->
        </div>
    
</div>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                main_pic: '',
                reward: {
                    first: {},
                    second: {},
                    three: {}
                }
            },
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.read();
        }

    },
    methods: {
        read: function () {
            this.http.post('/admin/huodong/read', {
                id: this.$route.query.id
            }).then(response => {
                this.formData = response;
                this.$set(this.formData, 'time', [response.s_time, response.e_time])
            })
        },

        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less">
.rankDet {
    .rankTime {
        background: #ffffff;
        padding: 10px 20px;
        box-sizing: border-box;
        margin-left: auto;
    }
}
</style>
